<template>
  <div class="fzf">
    <div class="fzfbox">
      <strong>{{title}}</strong>
      <div>{{text}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'footerNav',
  data() {
    return {}
  },
  props: {
    title: '',
    text: ''
  },
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fzf {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.notfind {
  height: 450px;
}


.pay {
  height: auto;
  margin-top: 30%;
  margin-bottom: 20px;
}

.fzfbox {
  width: 100%;
  padding-top: 190px;
  text-align: center;
  background: url(../../static/images/404.svg) center 0 no-repeat;
  font-size: 18px;
  line-height: 2;
}

</style>



// WEBPACK FOOTER //
// src/components/404.vue